import { authHeader,authHeaderAJ } from '../_helpers';
import  querystring  from 'query-string';

function getErrorResponse(msg)
{
    var errorResponse = {
        resultCode: 'ERROR',
        dataType: '',
        message: msg
    };

    return errorResponse;
}


export function RESPONSE(response) {
    var data = null; 
    return response.text().then(text => {
        try{
        data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) {
                return getErrorResponse('401 Unauthorized');
            }

            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }
    }
    catch (error){
        return getErrorResponse('Failed to parse server reponse');
    }
    return data;
    });
}

export function POST_FORM_DATA(url,params) {
    var body ='';

    if (params && params !== undefined){
        body = JSON.stringify(params);
    }else{
        body =JSON.stringify({});
    }
    
    const requestOptions = {
        method: 'POST',
        headers: authHeaderAJ('multipart/form-data'),
        body: body
    };

    return fetch(url,requestOptions);	
}


export function POST(url,params) {
    var body ='';

    if (params && params !== undefined){
        body = JSON.stringify(params);
    }else{
        body =JSON.stringify({});
    }

    const requestOptions = {
        method: 'POST',
        headers: authHeaderAJ(),
        body: body
    };

    return fetch(url,requestOptions);	
}


export function GET(url,params) {
   
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };
    
    var fullUrl = "";
    if (params)
        fullUrl = url+"?"+querystring.stringify(params);
    else
        fullUrl = url;
    return fetch(fullUrl,requestOptions);
}